import {
  CUSTOM_FIELD_OPTION,
  CUSTOM_FIELD_PREFIX,
  SCANNER_CREDENTIAL_FIELDS,
} from '@/_core/entities/scanner-credential-fields/models/constants';
import type {
  TNormalizedScannerCredentialField,
  TScannerCredentialField,
} from '@/_core/entities/scanner-credential-fields/models/types';

type TRawScannerCredentialField = Partial<TScannerCredentialField> | null | undefined;

export function normalizeScannerCredentialField(field: unknown): TNormalizedScannerCredentialField {
  const rawField = field as TRawScannerCredentialField;
  const rawFieldKey = typeof rawField?.fieldKey === 'string' ? rawField.fieldKey : '';
  const normalizedValue = typeof rawField?.value === 'string' ? rawField.value.trim() : '';
  const normalizedName = typeof rawField?.name === 'string' ? rawField.name.trim() : '';
  const isCustomByKey = isCustomFieldKey(rawFieldKey);
  const fieldType = isCustomByKey ? CUSTOM_FIELD_OPTION.fieldKey : rawFieldKey;
  const defaultDefinition = SCANNER_CREDENTIAL_FIELDS.find((item) => item.fieldKey === rawFieldKey);
  const customNameFromKey = getCustomFieldNameFromKey(rawFieldKey);
  const rawLabel = typeof rawField?.label === 'string' ? rawField.label : '';
  const label =
    normalizedName || customNameFromKey || rawLabel || defaultDefinition?.label || rawFieldKey;

  return {
    fieldKey: rawFieldKey,
    fieldType,
    label,
    name: normalizedName || customNameFromKey,
    value: normalizedValue,
  };
}

function isCustomFieldKey(fieldKey: string): boolean {
  if (fieldKey === CUSTOM_FIELD_OPTION.fieldKey) {
    return true;
  }

  return fieldKey.startsWith(CUSTOM_FIELD_PREFIX);
}

function getCustomFieldNameFromKey(fieldKey: string): string {
  if (!isCustomFieldKey(fieldKey)) {
    return '';
  }

  if (!fieldKey.startsWith(CUSTOM_FIELD_PREFIX)) {
    return '';
  }

  const keyWithoutPrefix = fieldKey.slice(CUSTOM_FIELD_PREFIX.length);
  const separatorIndex = keyWithoutPrefix.lastIndexOf('__');

  if (separatorIndex <= 0) {
    return '';
  }

  const encodedName = keyWithoutPrefix.slice(0, separatorIndex);

  try {
    return decodeURIComponent(encodedName);
  } catch {
    return '';
  }
}
